// Monograme deterministe pentru companii / persoane — inițiale + culoare stabilă
// derivată din nume (fără date personale, doar prezentare vizuală).

const PALETTE = [
  "#0d9488", // teal
  "#2e90fa", // blue
  "#7a5af8", // violet
  "#f79009", // amber
  "#12b76a", // green
  "#ef6820", // orange
  "#ee46bc", // pink
  "#6172f3", // indigo
  "#0ba5ec", // sky
  "#875bf7", // purple
];

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function avatarColor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
}
